import { isValidCoordinates } from "./isValidCoordinates";

export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
  if (!isValidCoordinates(lat1, lon1) || !isValidCoordinates(lat2, lon2)) return NaN;
  try {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return Number.isFinite(distance) ? distance : NaN;
  } catch {
    return NaN;
  }
};